import React, {Component} from 'react';
import {Button, Col, ControlLabel, Grid, Row} from 'react-bootstrap'
import '../styles/Wyszukiwarka.css'
import {Link} from "react-router-dom";
import Select from "react-select";
import 'react-select/dist/react-select.css';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import WyszukiwarkaService from "./WyszukiwarkaService";
import TopIf from "../topComponents/if/TopIf";
import 'moment/locale/pl';
import 'rc-time-picker/assets/index.css';
import strings from '../strings/localeStrings'
import {NotificationManager} from "react-notifications";

export default class Wyszukiwarka extends Component {

    constructor(props) {
        super(props);

        let miejsceWyjazduPrzystanek = {value: 123456, label: ''};
        let miejsceDocelowePrzystanek = {value: 123456, label: ''};
        let iloscOsob = 1;
        let dataWyjazdu = moment();
        let godzinaWyjazdu = moment().format('HH:mm');
        let dataPowrotu = moment().add(1, 'days');
        let godzinaPowrotu = moment().add(2, 'hours').format('HH:mm');
        let powrotny = false;

        this.state = {
            miejscowosci: [],
            przystankiWyjazdu: null,
            przystankiDocelowe: null,
            miejsceWyjazduPrzystanek: miejsceWyjazduPrzystanek,
            miejsceDocelowePrzystanek: miejsceDocelowePrzystanek,
            miejsceWyjazdu: null,
            miejsceDocelowe: null,
            godzinaWyjazdu: godzinaWyjazdu,
            dataWyjazdu: dataWyjazdu,
            godzinaPowrotu: godzinaPowrotu,
            dataPowrotu: dataPowrotu,
            iloscOsob: iloscOsob,
            powrotny: powrotny,
        };

        this.onChangeMiejsceWyjazdu = this.onChangeMiejsceWyjazdu.bind(this);
        this.onChangeMiejsceDocelowe = this.onChangeMiejsceDocelowe.bind(this);
        this.onChangeMiejsceWyjazduPrzystanek = this.onChangeMiejsceWyjazduPrzystanek.bind(this);
        this.onChangeMiejsceDocelowePrzystanek = this.onChangeMiejsceDocelowePrzystanek.bind(this);
        this.onChangeDataWyjazdu = this.onChangeDataWyjazdu.bind(this);
        this.onChangeGodzinaWyjazdu = this.onChangeGodzinaWyjazdu.bind(this);
        this.onChangeDataPowrotu = this.onChangeDataPowrotu.bind(this);
        this.onChangeGodzinaPowrotu = this.onChangeGodzinaPowrotu.bind(this);
        this.onChangeIloscOsob = this.onChangeIloscOsob.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.clickOutside = this.clickOutside.bind(this);
        this.clickOutside2 = this.clickOutside2.bind(this);
    }

    componentWillMount() {
        if (window.location.href.indexOf('search') > -1) {

            if (window.location.href.indexOf('powrotny') > -1) {
                this.setState({
                    powrotny: true,
                    dataPowrotu: moment(this.props.params.dataPow),
                    godzinaPowrotu: this.props.params.godzinaPow
                })
            }

            if (!isNaN(parseInt(this.props.params.mW)) && !isNaN(parseInt(this.props.params.mD))) {
                WyszukiwarkaService.getPrzystankiWyszukiwanie(this.props.params.mW, this.props.params.mD)
                    .then(function (response) {
                        let miejscowosci = [];
                        let przystankiOne = [];
                        let przystankiTwo = [];
                        let res = response.data;
                        for (let i = 0; i < res.miejscowosci.length; i++) {
                            miejscowosci.push({value: res.miejscowosci[i].idMi, label: res.miejscowosci[i].nazMi})
                        }
                        for (let i = 0; i < res.przystanki[0].length; i++) {
                            przystankiOne.push({value: res.przystanki[0][i].idPr, label: res.przystanki[0][i].nazPr})
                        }
                        for (let i = 0; i < res.przystanki[1].length; i++) {
                            przystankiTwo.push({value: res.przystanki[1][i].idPr, label: res.przystanki[1][i].nazPr})
                        }
                        this.props.miejscowoscOne(res.wybrane[0].idMi);
                        this.props.miejscowoscTwo(res.wybrane[1].idMi);
                        this.setState({
                            miejscowosci: miejscowosci,
                            miejsceWyjazdu: {value: res.wybrane[0].idMi, label: res.wybrane[0].nazMi},
                            miejsceWyjazduPrzystanek: {value: res.wybrane[0].idPr, label: res.wybrane[0].nazPr},
                            miejsceDocelowe: {value: res.wybrane[1].idMi, label: res.wybrane[1].nazMi},
                            miejsceDocelowePrzystanek: {value: res.wybrane[1].idPr, label: res.wybrane[1].nazPr},
                            przystankiWyjazdu: przystankiOne,
                            przystankiDocelowe: przystankiTwo,
                            godzinaWyjazdu: this.props.params.godzina,
                            dataWyjazdu: moment(this.props.params.data)
                        })
                    }.bind(this)).catch(error => {
                    console.log(error)
                })
                    .catch((e) => {
                        console.log(e)
                    })
            }
        } else {
            WyszukiwarkaService.getMiejscowosci()
                .then(function (response) {
                    let miejscowosci = [];
                    let res = response.data;
                    console.log(res)
                    for (let i = 0; i < res.length; i++) {
                        miejscowosci.push({value: res[i].idMi, label: res[i].nazMi})
                    }
                    this.setState({miejscowosci: miejscowosci})
                }.bind(this)).catch(error => {
                console.log(error)
            })
                .catch((e) => {
                    console.log(e)
                })
        }
    }

    keyPress(e) {
        if (e.keyCode === 13) {
            this.onSzukaj();
        }
    }

    onSzukaj() {
        if(this.state.miejsceWyjazdu.value === 49 || this.state.miejsceDocelowe.value === 49)
        {
            alert('Te kursy są realizowane przez naszego partnera.');
            window.open('https://www.flixbus.pl/', '_blank') || window.location.replace('https://www.flixbus.pl/');
        } else {
            this.props.onButtonClick();
        }
    }

    clickOutside() {
        this.refs.picker.cancelFocusInput();
        this.refs.picker.setOpen(false);
    }

    clickOutside2() {
        this.refs.picker2.cancelFocusInput();
        this.refs.picker2.setOpen(false);
    }

    checkPrzystanekLabel(przystanek) {
        przystanek = przystanek.replace('/', ' ');
        return przystanek
    }

    getPrzystanki(miejsceWyjazdu, miejsceDocelowe) {
        if (miejsceWyjazdu !== null && miejsceDocelowe !== null && miejsceWyjazdu > 0 && miejsceWyjazdu < 999 && miejsceDocelowe > 0 && miejsceWyjazdu < 999) {
            WyszukiwarkaService.getPrzystanki(miejsceWyjazdu, miejsceDocelowe)
                .then(function (response) {
                    let res = response.data;
                    let przystankiDocelowe = [];
                    let przystankiWyjazdu = [];

                    for (let i = 0; i < res[0].length; i++) {
                        przystankiWyjazdu.push({
                            value: res[0][i].idPr,
                            label: res[0][i].nazPr,
                            domyslny: res[0][i].domyslny
                        })
                    }
                    for (let i = 0; i < res[1].length; i++) {
                        przystankiDocelowe.push({
                            value: res[1][i].idPr,
                            label: res[1][i].nazPr,
                            domyslny: res[1][i].domyslny
                        })
                    }

                    let przystanekWyjazdu = przystankiWyjazdu[0];
                    let przystanekDocelowy = przystankiDocelowe[przystankiDocelowe.length - 1];

                    for (let i = 0; i < przystankiWyjazdu.length; i++) {
                        if (przystankiWyjazdu[i].domyslny === 1) {
                            console.log(przystankiWyjazdu[i]);
                            przystanekWyjazdu = przystankiWyjazdu[i]
                        }
                    }

                    for (let i = 0; i < przystankiDocelowe.length; i++) {
                        if (przystankiDocelowe[i].domyslny === 1) {
                            przystanekDocelowy = przystankiDocelowe[i]
                        }
                    }

                    this.setState({
                        przystankiDocelowe: przystankiDocelowe,
                        miejsceWyjazduPrzystanek: przystanekWyjazdu,
                        miejsceDocelowePrzystanek: przystanekDocelowy,
                        przystankiWyjazdu: przystankiWyjazdu
                    })
                }.bind(this))
        } else {
            NotificationManager.error("", "Wystąpił błąd ", 5000);
        }
    }

    onChangeMiejsceWyjazdu(e) {
        this.setState({
            miejsceWyjazdu: e,
            miejsceWyjazduPrzystanek: '',
            miejsceDocelowePrzystanek: '',
            powrotny: false
        });
        if (e !== null && this.state.miejsceDocelowe !== null && this.state.miejsceDocelowe !== undefined) {
            this.getPrzystanki(e.value, this.state.miejsceDocelowe.value);
            if (window.location.href.indexOf('search') > -1) {
                this.props.miejscowoscOne(e.value)
            }
        }
    }

    onChangeMiejsceDocelowe(e) {
        this.setState({
            miejsceDocelowe: e,
            miejsceWyjazduPrzystanek: '',
            miejsceDocelowePrzystanek: '',
            powrotny: false
        });
        if (e !== null && this.state.miejsceWyjazdu !== null && this.state.miejsceWyjazdu !== undefined) {
            this.getPrzystanki(this.state.miejsceWyjazdu.value, e.value);
            if (window.location.href.indexOf('search') > -1) {
                this.props.miejscowoscTwo(e.value)
            }
        }
    }

    onChangeMiejsceWyjazduPrzystanek(e) {
        this.setState({miejsceWyjazduPrzystanek: e})
    }

    onChangeMiejsceDocelowePrzystanek(e) {
        this.setState({miejsceDocelowePrzystanek: e})
    }

    onChangeDataWyjazdu(e) {
        if (moment(e).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') && this.state.godzinaWyjazdu < moment()) {
            this.setState({dataWyjazdu: e, godzinaWyjazdu: moment().format('HH:mm')})
        } else {
            if (moment(e).format('YYYY-MM-DD') > moment(this.state.dataPowrotu).format('YYYY-MM-DD')) {
                this.setState({dataPowrotu: e, dataWyjazdu: e})
            } else {
                this.setState({dataWyjazdu: e})
            }
        }

    }

    onChangeGodzinaWyjazdu(e) {
        console.log(e.target.value);
        if (moment(this.state.dataWyjazdu).format('YYYY-MM-DD') === moment(this.state.dataPowrotu).format('YYYY-MM-DD') && e.target.value > this.state.godzinaPowrotu) {
            this.setState({godzinaWyjazdu: e.target.value, godzinaPowrotu: e.target.value})
            this.props.setButtonLoader();
        } else {
            this.setState({godzinaWyjazdu: e.target.value})
            this.props.setButtonLoader();
        }
    }

    onChangeDataPowrotu(e) {
        if (moment(e).format('YYYY-MM-DD') < moment(this.state.dataWyjazdu).format('YYYY-MM-DD') || e.year() < this.state.dataWyjazdu.year()) {
            NotificationManager.error("", "Data powrotu nie może być wcześniejsza od daty wyjazdu ", 5000);
        } else {
            if (moment(e).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')&& this.state.godzinaPowrotu < moment().format('HH:mm')) {
                this.setState({dataPowrotu: e, godzinaPowrotu: this.state.godzinaWyjazdu})
            } else {
                this.setState({dataPowrotu: e})
            }
        }
    }

    onChangeGodzinaPowrotu(e) {
        if (moment(this.state.dataWyjazdu).format('YYYY-MM-DD') === moment(this.state.dataPowrotu).format('YYYY-MM-DD')) {
            if (e.target.value < this.state.godzinaWyjazdu) {
                this.setState({godzinaPowrotu: this.state.godzinaWyjazdu})
                this.props.setButtonLoader();
            } else {
                this.setState({godzinaPowrotu: e.target.value})
                this.props.setButtonLoader();
            }
        } else {
            this.setState({godzinaPowrotu: e.target.value})
            this.props.setButtonLoader();
        }
    }

    onChangeIloscOsob(e) {
        this.setState({iloscOsob: e.target.value})
    }

    odwrocTrase() {
        if (this.state.miejsceWyjazdu !== undefined && this.state.miejsceDocelowe !== undefined && this.state.miejsceWyjazdu !== null && this.state.miejsceDocelowe !== null) {
            this.getPrzystanki(this.state.miejsceDocelowe.value, this.state.miejsceWyjazdu.value);
            if (window.location.href.indexOf('search') > -1) {
                this.props.miejscowoscTwo(this.state.miejsceWyjazdu.value);
                this.props.miejscowoscOne(this.state.miejsceDocelowe.value)
            }
            this.setState({
                miejsceWyjazdu: this.state.miejsceDocelowe,
                miejsceDocelowe: this.state.miejsceWyjazdu,
                miejsceWyjazduPrzystanek: '',
                miejsceDocelowePrzystanek: '',
                przystankiWyjazdu: [],
                przystankiDocelowe: [],
                powrotny: false
            });
        } else {
            null
        }
    }

    render() {
        return (
            <div>
                <Grid>

                    <div id={'searchbox-container'} className="searchboxMobilka">
                        <Row>
                            <Col xs={12} lg={4}>
                                <Row>
                                    <Col xs={12} lg={9}>
                                        <ControlLabel>
                                            <i className={'fa fa-map-marker'}> </i> {strings.miejsceWyjazdu}
                                        </ControlLabel>
                                        <Select style={{height: 40}} ref={this.props.miejsceInput}
                                                value={this.state.miejsceWyjazdu}
                                                onChange={this.onChangeMiejsceWyjazdu}
                                                onBlur={event => event.preventDefault()}
                                                options={this.state.miejscowosci}
                                                placeholder={strings.wybierzMiejsce}
                                                clearable={false}
                                                noResultsText={'Brak wyników'}
                                                matchPos="start"/>
                                    </Col>
                                    <Col xs={12} lg={3} className="odwrocTrase"
                                         style={{textAlign: 'center', paddingTop: 40, color: '#57b13c'}}>
                                        <i className="fa fa-arrows-h" onClick={() => this.odwrocTrase()}> </i>
                                    </Col>

                                </Row>
                            </Col>
                            <Col xs={12} lg={3}>
                                <Row>
                                    <Col xs={12} lg={12}>
                                        <ControlLabel><i className={'fa fa-map-marker'}> </i> {strings.miejsceDocelowe}
                                        </ControlLabel>
                                        <Select style={{height: 40}} value={this.state.miejsceDocelowe}
                                                onChange={this.onChangeMiejsceDocelowe}
                                                onBlur={event => event.preventDefault()}
                                                noResultsText={'Brak wyników'}
                                                clearable={false}
                                                options={this.state.miejscowosci} placeholder={strings.wybierzMiejsce}
                                                matchPos="start"/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} lg={3}>
                                <Row className="dataWyjazduClass">
                                    <Col xs={3} lg={6} style={{padding: 0}} className="dataMobilkaClass">
                                        <ControlLabel><i className={'fa fa-calendar'}> </i> {strings.dataWyjazdu}
                                        </ControlLabel>
                                        <DatePicker
                                            dateFormat="YYYY-MM-DD"
                                            onClickOutside={this.clickOutside}
                                            style={{height: 40, paddingLeft: 0}}
                                            readOnly
                                            ref={"picker"}
                                            selected={this.state.dataWyjazdu}
                                            onChange={this.onChangeDataWyjazdu}
                                            locale="pl"
                                        />
                                    </Col>
                                    <Col xs={3} lg={5} style={{padding: 0}} className="dataMobilkaClass">
                                        <ControlLabel><i className={'fa fa-clock-o'}> </i> {strings.godzinaWyjazdu}
                                        </ControlLabel>
                                        <input type={'time'} required
                                               clearable={false}
                                               disabled={this.props.buttonLoader}
                                               style={{height: 40}}
                                               className={'form-control'}
                                               onKeyDown={this.keyPress}
                                               value={this.state.godzinaWyjazdu}
                                               onChange={this.onChangeGodzinaWyjazdu}
                                               onSelect={this.onChangeGodzinaWyjazdu}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} lg={1} className="buttonSzukajMobilka">
                                <Row>
                                    <Col xs={6} lg={12}>
                                        <div className={'pull-center'} style={{paddingTop: 3}}>
                                            {(this.state.miejsceWyjazduPrzystanek) && (this.state.miejsceWyjazduPrzystanek.label !== '') && (this.state.miejsceDocelowePrzystanek.label !== '') && (this.state.miejsceWyjazduPrzystanek.label !== undefined) && (this.state.miejsceDocelowePrzystanek.label !== undefined) && (this.state.godzinaWyjazdu !== '') && (/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(this.state.godzinaWyjazdu)) && (/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(this.state.godzinaPowrotu)) && (this.state.godzinaPowrotu !== '') ?
                                                <div>
                                                    <TopIf isTrue={this.state.powrotny}>
                                                        <Link onKeyDown={this.keyPress}
                                                              to={'/search/' + this.state.miejsceWyjazduPrzystanek.value + '/' + this.state.miejsceDocelowePrzystanek.value + '/' + this.state.dataWyjazdu.format('YYYY-MM-DD') + '/' + this.state.godzinaWyjazdu + '/powrotny/' + this.state.dataPowrotu.format('YYYY-MM-DD') + '/' + this.state.godzinaPowrotu}>
                                                            <Button
                                                                onClick={() => {
                                                                    this.onSzukaj();
                                                                }}
                                                                bsStyle={'warning'}
                                                                disabled={this.props.buttonLoader}
                                                                style={{marginTop: 30, color: 'white'}}>
                                                                <i className={this.props.buttonLoader ? 'fa fa-spinner fa-pulse fa-fw' : 'fa fa-search'}> </i> {strings.szukaj}
                                                            </Button></Link></TopIf>
                                                    <TopIf isTrue={!this.state.powrotny}>
                                                        <Link onKeyDown={this.keyPress}
                                                              to={'/search/' + this.state.miejsceWyjazduPrzystanek.value + '/' + this.state.miejsceDocelowePrzystanek.value + '/' + this.state.dataWyjazdu.format('YYYY-MM-DD') + '/' + this.state.godzinaWyjazdu}><Button
                                                            onClick={() => {
                                                                this.onSzukaj();
                                                            }}
                                                            bsStyle={'warning'}
                                                            disabled={this.props.buttonLoader}
                                                            style={{marginTop: 30, color: 'white'}}>
                                                            <i className={this.props.buttonLoader ? 'fa fa-spinner fa-pulse fa-fw' : 'fa fa-search'}> </i> {strings.szukaj}
                                                        </Button>
                                                        </Link></TopIf>
                                                </div>
                                                :
                                                <Button onClick={() => {
                                                    this.state.godzinaWyjazdu === '' || this.state.godzinaPowrotu === '' || (/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(this.state.godzinaPowrotu) === false) || (/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(this.state.godzinaWyjazdu) === false) ?

                                                        NotificationManager.error("", "Należy podać poprawne godziny w formacie 'hh:mm' ", 5000)
                                                        : NotificationManager.error("", "Należy podać miejscowości ", 5000)

                                                }}
                                                        bsStyle={'warning'} style={{marginTop: 30, color: 'white'}}>
                                                    <i className={'fa fa-search'}> </i> {strings.szukaj}</Button>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        {(this.state.miejsceWyjazdu !== null) && (this.state.miejsceDocelowe !== null) && (this.state.miejsceWyjazdu !== undefined) && (this.state.miejsceDocelowe !== undefined) ?
                            <Row style={{marginTop: 10}}>
                                <Col xs={12} lg={4} className="przystankiMobilka">
                                    <ControlLabel><i className={'fa fa-bus'}> </i> {strings.przystanekWyjazdu}
                                    </ControlLabel>
                                    <Select style={{height: 40}} value={this.state.miejsceWyjazduPrzystanek}
                                            placeholder="Wybierz przystanek"
                                            onChange={this.onChangeMiejsceWyjazduPrzystanek}
                                            options={this.state.przystankiWyjazdu}
                                            matchPos="start"
                                            clearable={false}
                                            noResultsText={'Brak wyników'}
                                    />
                                </Col>

                                <Col xs={12} lg={3} className="przystankiMobilka">
                                    <ControlLabel><i className={'fa fa-bus'}> </i> {strings.przystanekKoncowy}
                                    </ControlLabel>
                                    <Select style={{height: 40}}
                                            placeholder="Wybierz przystanek"
                                            value={this.state.miejsceDocelowePrzystanek}
                                            onChange={this.onChangeMiejsceDocelowePrzystanek}
                                            options={this.state.przystankiDocelowe}
                                            matchPos="start"
                                            clearable={false}
                                            noResultsText={'Brak wyników'}
                                    />
                                </Col>
                                {this.state.powrotny ?
                                    <Col xs={12} lg={3}>
                                        <Row className="dataWyjazduClass">
                                            <Col xs={12} lg={6} style={{padding: 0}} className="dataMobilkaClass">
                                                <ControlLabel><i
                                                    className={'fa fa-calendar'}> </i> {strings.dataPowrotu}
                                                </ControlLabel>
                                                <DatePicker
                                                    dateFormat="YYYY-MM-DD"
                                                    style={{height: 40}}
                                                    readOnly
                                                    ref={"picker2"}
                                                    onClickOutside={this.clickOutside2}
                                                    selected={this.state.dataPowrotu}
                                                    onChange={this.onChangeDataPowrotu}
                                                    locale="pl"
                                                />
                                            </Col>
                                            <Col xs={12} lg={5} style={{padding: 0}} className="dataMobilkaClass">
                                                <ControlLabel><i
                                                    className={'fa fa-clock-o'}> </i> {strings.godzinaWyjazdu}
                                                </ControlLabel>
                                                <input type={'time'} required
                                                       clearable={false}
                                                       disabled={this.props.buttonLoader}
                                                       style={{height: 40}}
                                                       className={'form-control'}
                                                       value={this.state.godzinaPowrotu}
                                                       onSelect={this.onChangeGodzinaPowrotu}
                                                       onChange={this.onChangeGodzinaPowrotu}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    :
                                    <Col xs={12} lg={5}>
                                        <div className="powrotText" onClick={() => this.setState({powrotny: true})}> +
                                            {strings.dodajDatePowrotu}
                                        </div>
                                    </Col>}
                            </Row>
                            : null}
                        <Row className="buttonSzukajPokazMobilka" style={{display: 'none'}}>
                            <Col xs={12} lg={1}>
                                <Row>
                                    <Col xs={6} lg={12}>
                                        <div className={'pull-center'} style={{paddingTop: 3}}>
                                            {(this.state.miejsceWyjazduPrzystanek) && (this.state.miejsceWyjazduPrzystanek.label !== '') && (this.state.miejsceDocelowePrzystanek.label !== '') && (this.state.miejsceWyjazduPrzystanek.label !== undefined) && (this.state.miejsceDocelowePrzystanek.label !== undefined) ?
                                                <div>
                                                    <TopIf isTrue={this.state.powrotny}>
                                                        <Link onKeyDown={this.keyPress}
                                                              to={'/search/' + this.state.miejsceWyjazduPrzystanek.value + '/' + this.state.miejsceDocelowePrzystanek.value + '/' + this.state.dataWyjazdu.format('YYYY-MM-DD') + '/' + this.state.godzinaWyjazdu + '/powrotny/' + this.state.dataPowrotu.format('YYYY-MM-DD') + '/' + this.state.godzinaPowrotu}>
                                                            <Button
                                                                onClick={() => {
                                                                    this.onSzukaj()
                                                                }}
                                                                bsStyle={'warning'}
                                                                style={{marginTop: 30, color: 'white'}}>
                                                                <i className={'fa fa-search'}> </i> {strings.szukaj}
                                                            </Button></Link></TopIf>
                                                    <TopIf isTrue={!this.state.powrotny}>
                                                        <Link onKeyDown={this.keyPress}
                                                              to={'/search/' + this.state.miejsceWyjazduPrzystanek.value + '/' + this.state.miejsceDocelowePrzystanek.value + '/' + this.state.dataWyjazdu.format('YYYY-MM-DD') + '/' + this.state.godzinaWyjazdu}><Button
                                                            onClick={() => {
                                                                this.onSzukaj()
                                                            }}
                                                            bsStyle={'warning'}
                                                            style={{marginTop: 30, color: 'white'}}>
                                                            <i className={'fa fa-search'}> </i> {strings.szukaj}
                                                        </Button>
                                                        </Link></TopIf>
                                                </div>
                                                :
                                                <Button onClick={() => {
                                                    NotificationManager.error("", "Należy podać miejscowości ", 5000)
                                                }}
                                                        bsStyle={'warning'} style={{marginTop: 30, color: 'white'}}>
                                                    <i className={'fa fa-search'}> </i> {strings.szukaj}</Button>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/wyszukiwarka/Wyszukiwarka.js